
import './App.css';
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
import {Routes,Route} from "react-router-dom"
import RSA from './Components/RSA';
import Authors from './Components/Authors';
function App() {
 
  return (
      <div className='h-screen text-sky-900  dark:bg-[#0a192f] font-sans '>

        
 
      <Navbar/>
      <hr className='text-[#0a192f] dark:text-gray-400  mx-auto' />


    <Routes>
      <Route  path='/' element={<Home/>}/>
      <Route path='/rsa' element={<RSA/>}/>
      <Route path='/authors' element={<Authors/>}/>
    </Routes>
    </div>
    


  )
}

export default App